/**
 * Die Danke-Seite: Bestellnummer, Vorschau, Nachkauffrage.
 *
 * Drei kleine Aufgaben, eine Datei, weil sie nur auf einer Seite
 * gebraucht werden. Die Section lädt sie selbst, das Layout nicht.
 *
 * 1. BESTELLNUMMER
 *    Auf Shopify Basic ersetzt das Theme die Bestellstatus-Seite nicht
 *    (Prüfpunkt 1 der Spec). Liegt kein Bestellobjekt vor, kommt die
 *    Nummer aus dem Adressparameter bestellung. Fehlt auch der, bleibt
 *    die Zeile ausgeblendet: eine Kopfzeile ohne Nummer wäre eine
 *    Behauptung.
 *
 * 2. VORSCHAU
 *    Das Kaufmodul legt die zuletzt bestätigte Vorschau beim Absenden
 *    als Data-URL unter dem sessionStorage-Schlüssel ff_letzte_vorschau
 *    ab. Sie ist ein Notbehelf für die Seitenfassung, kein Ersatz für
 *    das Bild am Auftrag: an das Gerät und an die Sitzung gebunden.
 *    Liegt schon ein Bild aus dem Bestellobjekt im Markup, wird nichts
 *    angefasst.
 *
 *    Die Vorschau hängt an der Bestellnummer, nicht am Tab (A-526).
 *    Beim ersten Aufruf mit einer Nummer wird die letzte Vorschau an
 *    diese Nummer gebunden und als "letzte" verbraucht. Eine zweite
 *    Bestellung im selben Tab bringt ihre eigene Vorschau mit, und wer
 *    die erste Nummer wieder aufruft, sieht wieder die erste Zeile.
 *    Ohne Nummer in der Adresse wird nichts gezeigt. Vorher stand unter
 *    "Bestellung 1001" die Zeile eines anderen Rahmens.
 *
 *    Was das Theme nicht wissen kann: ob die Vorschau wirklich zu
 *    dieser Bestellung gehört, denn beim Absenden gibt es die Nummer
 *    noch nicht. Deshalb wechselt die Zeile darüber ihren Wortlaut und
 *    behauptet keine Zuordnung. Alles bleibt in sessionStorage und endet
 *    mit dem Tab, kein dauerhafter Speicher.
 *
 * 2a. DAS EIGENE FOTO (Vertrag v1, 16.10.2026)
 *    Kommt nur aus dem Bestellobjekt, das Liquid rendert es
 *    (sections/danke.liquid, snippets/foto-miniatur.liquid). Dieses
 *    Skript fasst den Block nicht an, es gibt bewusst keinen Rückfall
 *    aus der Sitzung (Review 17.10.2026): ein Merkplatz je Tab weiß
 *    nicht, zu welcher Bestellung ein Foto gehört, und zeigte nach einem
 *    späteren Kauf mit Karte nichts oder nach einem gescheiterten
 *    Hinzufügen das Foto unter der nächsten Bestellung. Lieber kein Foto
 *    als ein falsches.
 *
 * 3. NACHKAUFFRAGE
 *    Freiwillig. Die Antwort wird als attributes[nachkauffrage] über
 *    POST /cart/update.js abgelegt und lokal bestätigt.
 *
 *    EHRLICH ZUR GRENZE: nach einem Checkout ist der Warenkorb leer und
 *    neu. Die Antwort landet dann an keiner Bestellung. Wahrheitsquelle
 *    ist laut Trackingplan die Ablage beim Bestellexport, und die gibt
 *    es ohne eigenen Dienst nicht. Siehe docs/MESSUNG.md.
 *
 * Kein Fremdabruf, kein Pixel, keine Bibliothek. Die Einwilligungs-
 * verwaltung kommt als App, nicht als Skript im Theme.
 */
(function () {
  'use strict';

  var VORSCHAU_SCHLUESSEL = 'ff_letzte_vorschau';

  function ausAdresse(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (fehler) {
      return null;
    }
  }

  /* ---------- 1. Bestellnummer ---------- */
  function bestellnummerSetzen() {
    var stelle = document.querySelector('[data-ff-bestellnummer]');
    if (!stelle || !stelle.hidden) return;

    var nummer = ausAdresse('bestellung');
    if (!nummer) return;

    /* Nur, was auf einer Bestellnummer vorkommt. Alles andere könnte
       fremder Text sein, der über die Adresse in die Seite käme. */
    nummer = nummer.replace(/[^A-Za-z0-9#.\-]/g, '').slice(0, 32);
    if (!nummer) return;

    var vorsatz = stelle.getAttribute('data-vorsatz') || '';
    stelle.textContent = vorsatz ? vorsatz + ' ' + nummer : nummer;
    stelle.hidden = false;
  }

  /* ---------- 2. Vorschau ---------- */
  var GEBUNDEN_VORSATZ = 'ff_vorschau_zu_';

  function nummerAusAdresse() {
    var nummer = ausAdresse('bestellung');
    if (!nummer) return '';
    return nummer.replace(/[^A-Za-z0-9#.\-]/g, '').slice(0, 32);
  }

  function istBild(quelle) {
    /* Nur eine Data-URL mit Bild. Alles andere wird nicht angefasst:
       ein src aus fremder Hand hat auf dieser Seite nichts verloren. */
    return !!quelle && quelle.slice(0, 11) === 'data:image/';
  }

  function vorschauZurNummer(nummer) {
    var speicher = window.sessionStorage;
    var gebunden = speicher.getItem(GEBUNDEN_VORSATZ + nummer);
    if (istBild(gebunden)) return gebunden;

    var letzte = speicher.getItem(VORSCHAU_SCHLUESSEL);
    if (!istBild(letzte)) return '';

    /* Binden und verbrauchen: die nächste Bestellung im selben Tab
       findet hier nichts Fremdes mehr vor. */
    speicher.setItem(GEBUNDEN_VORSATZ + nummer, letzte);
    speicher.removeItem(VORSCHAU_SCHLUESSEL);
    return letzte;
  }

  function vorschauSetzen() {
    var behaelter = document.querySelector('[data-ff-vorschau]');
    if (!behaelter) return;
    if (behaelter.querySelector('img')) return;

    var nummer = nummerAusAdresse();
    if (!nummer) return;

    var quelle;
    try {
      quelle = vorschauZurNummer(nummer);
    } catch (fehler) {
      return;
    }
    if (!quelle) return;

    var bild = document.createElement('img');
    bild.src = quelle;
    /* Der Alternativtext kommt aus dem Liquid (locales/*.json), der
       deutsche Fallback greift nur, wenn das Attribut fehlt. */
    bild.alt = behaelter.getAttribute('data-alt-aus-sitzung') || 'Die Zeile, die du zuletzt bestätigt hast';
    bild.width = 280;
    bild.height = 50;

    behaelter.textContent = '';
    behaelter.appendChild(bild);

    var zeile = document.querySelector('[data-ff-vorschau-zeile]');
    var ersatz = zeile && zeile.getAttribute('data-aus-sitzung');
    if (zeile && ersatz) zeile.textContent = ersatz;
  }

  /* ---------- 3. Nachkauffrage ---------- */
  function frageStarten() {
    var block = document.querySelector('[data-ff-nachkauffrage]');
    if (!block) return;

    /* Sie ist ohne Skript ausgeblendet, weil sie ohne Skript nichts
       ablegen kann. Jetzt gibt es das Skript, also darf sie sichtbar
       werden. */
    block.hidden = false;

    var form = block.querySelector('[data-ff-frageform]');
    var freitextfeld = block.querySelector('[data-ff-freitextfeld]');
    var quittung = block.querySelector('[data-ff-quittung]');
    var ueberspringen = block.querySelector('[data-ff-ueberspringen]');

    if (ueberspringen) {
      ueberspringen.addEventListener('click', function () {
        block.hidden = true;
      });
    }

    /* Das Freitextfeld erscheint erst, wenn "Anders" gewählt ist.
       Vorher steht es im Weg und sieht aus wie ein Pflichtfeld. */
    block.addEventListener('change', function () {
      if (!freitextfeld) return;
      var anders = block.querySelector('[data-ff-anders]');
      freitextfeld.hidden = !(anders && anders.checked);
    });

    if (!form) return;

    form.addEventListener('submit', function (ereignis) {
      ereignis.preventDefault();

      var gewaehlt = form.querySelector('input[name="nachkauffrage"]:checked');
      if (!gewaehlt) return;

      var antwort = gewaehlt.value;
      if (antwort === 'anders') {
        var eingabe = form.querySelector('#nachkauffrage-freitext');
        var text = eingabe && eingabe.value ? eingabe.value.trim().slice(0, 120) : '';
        antwort = text ? 'anders: ' + text : 'anders';
      }

      /* Die Bestätigung steht sofort, unabhängig davon, ob die Ablage
         klappt. Der Kunde hat seinen Teil getan, das ist nicht sein
         Problem. */
      form.hidden = true;
      if (quittung) quittung.hidden = false;

      if (!window.fetch) return;

      var nutzlast = { nachkauffrage: antwort };
      var nummer = ausAdresse('bestellung');
      if (nummer) nutzlast.nachkauffrage_bestellung = nummer.slice(0, 32);

      window
        .fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: nutzlast })
        })
        .catch(function () {
          /* Eine gescheiterte Ablage darf nichts anzeigen. Sie ist ein
             Messwert, keine Zusage. */
        });
    });
  }

  function starten() {
    bestellnummerSetzen();
    vorschauSetzen();
    frageStarten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();
